<template>
  <div class="logo-container cursor-pointer" 
    @click="redirectToLibrary">
    <base-image :src="url" class="px-2" />
  </div>
</template>

<script>
import { appRoutes } from "Public/consts/appRoutes";
import BaseImage from "Public/components/BaseImage";
import { STATIC_IMG_PATH } from "Consts/static";
export default {
  name: "Logo",
  components: { BaseImage },
  props: {
    url: {
      type: String,
      default: `${STATIC_IMG_PATH}/logo.svg`,
    },
  },
  methods: {
    async redirectToLibrary() {
      await this.$router.push(
        appRoutes.library 
      );
    },
  },
};
</script>

<style lang="scss">
@import "~PublicStyles/_variables.scss";
.logo-container {
  position: relative;
  height: 63px;
  width: 240px;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 50px;
    width: 100%;
  }

  @media ($tablet) {
    height: 63px;
  }

  @media ($mobile) {
    height: 56px;
  }
}
</style>
